import { createFileRoute } from '@tanstack/react-router';
import { TenantsPage } from '@/features/tenant/list-page';

export const Route = createFileRoute('/_authenticated/tenants')({
  validateSearch: (
    search: Record<string, unknown>,
  ): { invitation?: string } => ({
    invitation:
      typeof search.invitation === 'string' &&
      /^[a-zA-Z0-9_-]{1,128}$/.test(search.invitation)
        ? search.invitation
        : undefined,
  }),
  component: TenantRoute,
});

function TenantRoute() {
  const { invitation } = Route.useSearch();
  return <TenantsPage invitationId={invitation} />;
}
